import { AppState } from 'Store'

const getListAgent = (state: AppState) =>
	state.registryBusinessAccess.rbidosAgent.list_agent?.results ?? []
const getTotalAgent = (state: AppState) =>
	state.registryBusinessAccess.rbidosAgent.list_agent?.count ?? 0
const selectAgent = (state: AppState) => state.registryBusinessAccess.rbidosAgent.agent
const getAccessAgents = (state: AppState) =>
	state.registryBusinessAccess.rbidosAgent.access_agents?.results ?? []

const getAllListAgent = (state: AppState) =>
	state.registryBusinessAccess.rbidosAgent.all_list_agent?.results ?? []
const getIdentificationPoints = (state: AppState) => state.registryBusinessAccess.rbidosAgent.points
const getNewAgent = (state: AppState) => state.registryBusinessAccess.rbidosAgent.new_agent
const getCurrentRequestListAgent = (state: AppState) =>
	state.registryBusinessAccess.rbidosAgent.requestParamsListAgent
const getCurrentRequestAccessAgent = (state: AppState) =>
	state.registryBusinessAccess.rbidosAgent.requestParamsAccessAgent
const getCurrentRequestAllListAgent = (state: AppState) =>
	state.registryBusinessAccess.rbidosAgent.requestParamsAllListAgent

export const rbidosAgentSelector = {
	getListAgent,
	getTotalAgent,
	selectAgent,
	getAccessAgents,
	getAllListAgent,
	getIdentificationPoints,
	getNewAgent,
	getCurrentRequestListAgent,
	getCurrentRequestAccessAgent,
	getCurrentRequestAllListAgent,
}
